import { useEffect, useState } from 'react';
import { isMaintenanceActive } from '@/utils/maintenance';

/**
 * `isMaintenanceActive` reactivo: re-renderiza al llegar `expiresAt`, así la
 * válvula de expiración se refleja sin esperar a otro snapshot. Compartido por
 * la cortina y el indicador de estado para que ninguno quede sin el timer.
 *
 * @param {Parameters<typeof isMaintenanceActive>[0]} maintenance
 * @returns {boolean}
 */
export default function useMaintenanceActive(maintenance) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const expiresAtMs = maintenance?.expiresAt?.toMillis?.();
    if (maintenance?.active !== true || typeof expiresAtMs !== 'number') return undefined;
    const delay = expiresAtMs - Date.now();
    if (delay <= 0) return undefined;
    const timerId = setTimeout(() => setTick((t) => t + 1), delay + 1000);
    return () => clearTimeout(timerId);
  }, [maintenance]);

  return isMaintenanceActive(maintenance);
}
